import React, { FC, useEffect, useState } from 'react';
import RegisterParent from './steps/RegisterParent';
import Launcher from './steps/Launcher';
import ConnectToLesson from './steps/ConnectToLesson';
import RegisterChild from './steps/RegisterChild';
import ProgressCard from './ProgressCard/ProgressCard';
import { useRedux } from 'use-redux';
import SignInParent from './steps/SignInParent';
import styles from './styles.module.scss';
import { Button, Steps } from 'antd';
import { lessonApi } from '@api/lesson';
import { formatDate } from '@utils/date';
import { COURSES_FOR_SELECT } from '@constants/lessons';
import { I18n } from 'react-redux-i18n';
import { STEP } from './constants';

const Onboarding: FC<{}> = props => {
  const [info, setInfo] = useState<any>({});
  const [step, setStep] = useState(STEP.REGISTER_PARENT);
  const {
    params: { id: lessonId },
  } = props as any;

  const [
    {
      auth: { user },
    },
  ] = useRedux();

  useEffect(() => {
    if (!lessonId) return;
    lessonApi.getOnboardingInfo(lessonId).then(setInfo);
  }, [lessonId]);

  useEffect(() => {
    if (!user || (user.type === 'child' && !user.parent)) {
      setStep(STEP.REGISTER_PARENT);
    } else {
      setStep(STEP.REGISTER_CHILD);
    }
  }, [user]);

  const onRegisterChildComplete = () => {
    setStep(STEP.LAUNCHER);
  };

  const onLauncherChildComplete = () => {
    setStep(STEP.CONNECT);
  };

  const onRegister = () => {
    setStep(STEP.REGISTER_PARENT);
  };

  const onSignIn = () => {
    setStep(STEP.SIGNIN_PARENT);
  };

  const course: any = COURSES_FOR_SELECT.find(x => x.value === info.course);

  let persent = 0;
  let stepIndex = 0;

  if (step === STEP.CONNECT) {
    persent = 100;
    stepIndex = 2;
  }

  if (step === STEP.LAUNCHER) {
    persent = 50;
    stepIndex = 1;
  }

  return (
    <div className={styles.wrapper}>
      <div className={styles.container}>
        <h1 className={styles.title}>{I18n.t('onboarding.title')}</h1>
        <div className={styles.info}>
          <div style={{ flexGrow: 1 }}>
            <div>
              <b>{I18n.t('onboarding.note')}</b>
            </div>
            <div>
              {I18n.t('onboarding.start')}:{' '}
              <span className={styles.time}>
                {formatDate(info.start, 'DD MMMM, HH:mm')}
              </span>
            </div>
            <div>
              {I18n.t('onboarding.course')}: {course && course.label}
            </div>
          </div>

          <ProgressCard percent={persent} />
        </div>

        <Steps
          className={styles.steps}
          labelPlacement="vertical"
          current={stepIndex}
        >
          <Steps.Step title={I18n.t('onboarding.step1')} />
          <Steps.Step title={I18n.t('onboarding.step2')} />
          <Steps.Step
            title={`${I18n.t('onboarding.step3')} ${formatDate(
              info.start,
              'DD MMMM, HH:mm'
            )}`}
          />
        </Steps>

        {step === STEP.REGISTER_PARENT && (
          <RegisterParent onSignIn={onSignIn} />
        )}
        {step === STEP.SIGNIN_PARENT && (
          <SignInParent onRegister={onRegister} />
        )}
        {step === STEP.REGISTER_CHILD && (
          <RegisterChild onComplete={onRegisterChildComplete} />
        )}
        {step === STEP.LAUNCHER && (
          <Launcher onComplete={onLauncherChildComplete} />
        )}
        {step === STEP.CONNECT && <ConnectToLesson lessonId={lessonId} />}

        <div style={{ textAlign: 'end' }}>
          <Button
            type="link"
            onClick={() => {
              const { carrotquest } = window as any;
              if (carrotquest) carrotquest.openMessenger();
            }}
          >
            {I18n.t('onboarding.help')}
          </Button>
        </div>
      </div>
    </div>
  );
};

export default Onboarding;
